import React from 'react';

import PropTypes from 'prop-types';

const ENDPOINTS = {
    manufacturer: 'manufacturer',
    line: 'line',
    mattresscollection: 'collection',
    mattress: 'mattress'
};

const PRODUCT_HEADERS = {
    manufacturer: 'Starting Price',
    line: 'Starting Price',
    mattresscollection: 'Starting Price',
    mattress: 'Mattress Price',
};

const COMPONENT_HEADERS = {
    foundation: 'Foundation Price',
    adjustablebase: 'Adj. Base Price',
    topper: 'Topper Price',
    frame: 'Frame Price',
    protector: 'Protector Price',
    pillow: 'Pillow Price',
    bedding: 'Bedding Price',
    othercomponent: 'Other Component Price'
};

const PRICE_HEADERS = {...PRODUCT_HEADERS, ...COMPONENT_HEADERS};

const DIMENSIONS = {
    1: '39" x 75"', // Twin (Single)
    2: '39" x 80"', // Twin XL
    3: '54" x 75"', // Full (Double)
    5: '60" x 80"', // Queen
    6: '76" x 80"', // King
    7: '72" x 84"', // Cal King
};

class PriceTableComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            prices: [],
            componentPrices: [],
            showGoodbedDiscount: false
        };

        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;

        const productType = this.props.productType;
        const slug = this.props.slug;
        const components = this.props.components;

        for (const component of components) {
            const componentUrl = `/api/v2/component/${component.id}/prices/`;

            $.ajax({
                url: componentUrl,
                success: rs => {
                    const componentPrices = this.state.componentPrices;
                    componentPrices[component.classname] = rs.prices;

                    this._isMounted && this.setState({componentPrices: componentPrices});
                }
            });
        }

        const endpoint = PriceTableComponent.getEndpoint(productType);
        const url = `/api/v2/${endpoint}/${slug}/prices/`;

        $.ajax({
            url: url,
            success: rs => {
                this._isMounted && this.setState({
                    prices: rs.prices,
                    showGoodbedDiscount: rs.prices.length !== 0
                        && rs.prices.every(price => Object.entries(price.promo).length !== 0)
                });

                setTimeout(window.enableShowCodeButton, 300);
            }
        });
    }

    static getEndpoint(endpointType) {
        return ENDPOINTS[endpointType];
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const {components, productType} = this.props;
        const {prices, componentPrices, showGoodbedDiscount} = this.state;

        return (
            <table border="0">
                <tbody>
                <tr className="text-center">
                    <td>Bed Size</td>
                    <td>{PRICE_HEADERS[productType]}</td>

                    {components.map((component, componentIndex) => {
                        return <td key={componentIndex}>{PRICE_HEADERS[component.classname]}</td>;
                    })}

                    {showGoodbedDiscount && <td>GoodBed Discount</td>}
                </tr>
                {prices.map((price, index) => {
                    return (
                        <tr key={index} className="price-table-data">
                            <td>
                                <div className="price-table-grid-container">
                                    <span className="font-weight-bolder">{price.size}</span>
                                    <span className="dimension-item-data">({DIMENSIONS[price.size_code]})</span>
                                </div>
                            </td>
                            <td className="text-center font-weight-bolder">{price.price}</td>

                            {components.map((component, componentIndex) => {
                                const componentPrice = componentPrices[component.classname]
                                    .filter(p => p.size_code === price.size_code)[0];

                                return <td key={componentIndex}
                                           className="text-center component-item-data">{componentPrice.price}</td>;
                            })}

                            {showGoodbedDiscount &&
                                <td className="text-center">
                                    <div className="price-table-grid-container">
                                        <a className="font-weight-bolder"
                                           data-show-code="true"
                                           data-promotion={price.promo.id}
                                           data-outbound-url={price.promo.outbound_url}
                                           data-object-slug={this.props.slug}
                                           data-claimable={price.promo.claimable ? 'true' : 'false'}
                                           rel="nofollow">{price.promo.title}</a>
                                        <span className="detail-item-info">(click for details)</span>
                                    </div>
                                </td>
                            }
                        </tr>)
                })}
                </tbody>
            </table>
        );
    }
}

PriceTableComponent.propTypes = {
    slug: PropTypes.string,
    productType: PropTypes.string,
    components: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            classname: PropTypes.string,
            slug: PropTypes.string
        }))
};

export default PriceTableComponent;
